import { UpdateMobileUserComponent } from './update-mobile-user/update-mobile-user.component'
import { CreateMobileUserComponent } from './create-mobile-user/create-mobile-user.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { MobileUsersComponent } from './mobile-users.component'

import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'
import { MobileUserTasksComponent } from './mobile-user-tasks/mobile-user-tasks.component'

export const mobileUsersRoutes: Routes = [
  {
    path: 'admin/mobile-users',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'MOBILE_USERS',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: MobileUsersComponent,
        data: {
          permissions: {
            only: 'MOBILE_USERS',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateMobileUserComponent,
        data: {
          permissions: {
            only: 'MOBILE_USERS',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateMobileUserComponent,
        data: {
          permissions: {
            only: 'MOBILE_USERS',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/tasks',
        component: MobileUserTasksComponent,
        data: {
          permissions: {
            only: 'MOBILE_USERS',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
